import {
    isMobile,
} from '@/utils/detect.js';

// 引入hooks
import useTrack from '@/hooks/useTrack';

// Mobile设备
if (isMobile) {
    // 打默认点
    useTrack('mobile')?.trackEvent('site', 'show', 'init');

    // import('./mobile/main.js');
}
// PC设备
else {
    // 打默认点
    useTrack('pc')?.trackEvent('site', 'show', 'init');

}
import('./pc/main.js');